<div
  class="p-3 mb-1 break-all bg-[#19533e] w-fit rounded-r-lg border-l-4"
  [class]="getBorderColorClassByErrorType(record)"
>
  <span>{{ index + 1 }}.</span>
  {{ record.graph }}
  @if (record.items) {
    {{ record.name }}
  } @else {
    <span class="underline" (click)="showField()">
      {{ record.name }}
    </span>
  }
  <span
    class="message-text"
    [innerHtml]="sanitizedHtml(record.message.text)"
  ></span>

  @if (record.items) {
    @if (record.items.length < 5) {
      @for (item of record.items; track $index) {
        <ng-template
          *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
        ></ng-template>
      }
    } @else {
      @for (item of record.items.slice(0, 5); track $index) {
        <ng-template
          *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
        ></ng-template>
      }
      @if ((extended$ | async) === false) {
        <span class="mr-1" (click)="extended$.next(true)"> ... </span>
      } @else {
        @for (item of record.items.slice(5); track $index) {
          <ng-template
            *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
          ></ng-template>
        }
      }
    }

    <tui-icon icon="tuiIconCopy" (click)="copyIndexes()"></tui-icon>
  }
  <ng-container
    *polymorpheusOutlet="errorAction; context: { $implicit: record }"
  ></ng-container>
  <button
    appearance="control-error-solved"
    size="xs"
    tuiIconButton
    class="mx-1 cursor-pointer"
    (click)="markAsSolved()"
  ></button>
</div>

<ng-template #itemTemplate let-item>
  <span
    class="cursor-pointer underline text-[var(--tui-status-warning)] font-medium"
    (click)="showElementField(getIndexFromItem(item))"
  >
    {{ getIndexFromItem(item) }}
  </span>
  <span class="text-transparent mr-0.5">,</span>
</ng-template>
